import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { deleteShippingMethod } from "../../api/apiShipping";
import parseError from "../../utils/parseError";

export const useDeleteShippingMethod = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteShippingMethodMutate, isPending: isDeleting } = useMutation({
        mutationFn: deleteShippingMethod,
        onSuccess: (res) => {
            toast.success(res.message || "Shipping method deleted successfully");
            queryClient.invalidateQueries(["shipping-methods"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to delete shipping method");
        },
    });

    return { deleteShippingMethodMutate, isDeleting };
};
